/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon24Solid = forwardRef('UiMenuDots3HIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.253 12a2.248 2.248 0 1 0 4.497 0 2.248 2.248 0 0 0-4.497 0Z" }),
        React.createElement("path", { d: "M12 14.248a2.248 2.248 0 1 1 0-4.496 2.248 2.248 0 0 1 0 4.496Z" }),
        React.createElement("path", { d: "M19.502 14.248a2.248 2.248 0 1 1 0-4.496 2.248 2.248 0 0 1 0 4.496Z" })));
});
